<template>
    <div class="bg-white">

     


        <CTabs variant="pills">
              <CTab title="Event">
                <div>
            <CCol sm="12" lg="12" class="mx-auto" style="width: 100%; background-size: cover; color: #000;">
                <h3 class="custom-24px-500 text-left mt-4">Payment Event Tournament</h3>
                <h4 class="custom-16px-500 text-left font-color-AEAEB2">Handle payments for tournament entry fees, ensuring seamless participation in exciting competitive events.</h4>
                <div>
                    <div class="table-container" style="overflow-x:auto; max-width: 100%;">
                        <table class="table table-responsive-sm mt-4">
                            <thead>
                                <th>Event Name</th>
                                <th>Organizer</th>
                                <th>Date</th>
                                
                                <th>Ticket Sold</th>
                                <th>Ticket Price</th>
                                <th>Payment Status</th>
                            </thead>
                            <tbody v-for="(item, index) in tour" :key="item.Id">
                                <tr>
                                    <td> {{ item.Title }}</td>
                                    <td> {{ item.Organizer }}</td>
                                    <td> {{ item.start }}</td>
                                   
                                    <td>{{item.CountTeam }}</td>
                                    <td>RM {{item.Amount}}</td>
                                    <td>
                                        <span class="custom-badge-success">Paid</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </CCol>

            <div v-if="isPopupTeam" class="popup-all backdrop-all">
            <div class="popup-all2">
                <div class="text-right">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupTeam" />
                </div>
    
                <!-- Popup content -->
                <div class="custom-scroll">
                    <div class="text-left" v-for="(item, index) in teamgroup" v-bind:key="item.Id">
                        <CRow>
                            <CCol sm="11">
                                <h3 class="custom-20px-600 text-left mt-2">{{index+1 }} ).{{ item.teamName }}</h3>
                            </CCol>
                        </CRow>
    
                          
                     
                    </div>
                </div>
            </div>
        </div>

        </div>


    </CTab>
              <CTab title="Member Fees">
                <h3 class="custom-24px-500 text-left mt-4">Payment Member Fees</h3>
                <h4 class="custom-16px-500 text-left font-color-AEAEB2">Manage and process payments for membership subscriptions, providing access to exclusive benefits and services within the club</h4>
                <div v-if="participant && participant.length > 0">
                    <table class="table p-20 table-responsive-sm mt-4">
                        <thead style="background-color: #F9FAFB;color:#737373">
                            <th></th>
                            <th>Month</th>
                            <th>Tournament Name</th>
                            <th>Team Name</th>
                            <th>Phone</th>
                            <th>Amount</th>
                            <th>Status</th>
                        </thead>
                        <tbody v-for="(item,index) in participant" v-bind:key="item.Id">
                            <tr>
                                <td>{{index+1}}
                                <td><label style="white-space: nowrap;">{{ item.CreatedDate | moment("MMM YYYY")}}</label></td>
                                <td>{{item.TournamentName}}</td>
                                <td>{{item.TeamName}}</td>
                                <td>{{ item.PhoneNumber}}</td>
                                <td>RM {{ item.Price }}</td>
                                <td><span class="custom-badge-success">Paid</span></td>
                               
                            </tr>
                           
                        </tbody>

                    </table>
                    </div>
                    <CRow v-else class="text-center custom-scroll-div">
                        <CCol>
                            <img src="../assets/img/nodata.png" alt="No Data" style="max-width:200px; margin:auto;" />
                        </CCol>
                    </CRow>
              </CTab>
            
            </CTabs>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";
import moment from "moment";
Vue.use(require("vue-moment"));
Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,
            tour: [],
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            teamgroup: [],
            isPopupTeam:false,
            participant: [],


        };
    },
    created() {
        AOS.init();

    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler() {
                this.$forceUpdate(); // Forces re-render on language change
            }
        }
    },
    computed: {
        CreationDate() {
            return moment().startOf('day'); // Start of today
        },
        daysInMonth() {
            const days = [];
            const date = new Date(this.currentYear, this.currentMonth, 1);

            // Adjust start date to Sunday of the week
            date.setDate(date.getDate() - date.getDay());

            // Loop through each day in the calendar grid (5-6 weeks typically)
            for (let i = 0; i < 42; i++) {
                const dayEvents = this.getEventsForDate(date);
                days.push({ date: new Date(date), events: dayEvents });
                date.setDate(date.getDate() + 1); // Go to next day
            }
            return days;
        },
        monthName() {
            return new Date(this.currentYear, this.currentMonth).toLocaleString("default", { month: "long" });
        }
    },
    async mounted() {

        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
               await this.GetListTour();
               await this.GetListPartipantPayment();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    methods: {
          async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
      
        GetListTour() {
            this.$API
                .get(this.$GetListTournamentByUserId, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.tour = response.data;
                        this.getThumbnail(this.tour.FilePath);
                    }
                });
        },
      
        getThumbnail(index) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + this.tour[index].FilePath
            );
        },
        openTeam(item)
        {
            this.GetListTeamGroup(item.Category,item.Id);
            this.isPopupTeam = true;
        },
        GetListTeamGroup(category,id) {
            this.$API
                .get(this.$GetListTeamGroupbyCategory + "?category=" + category + "&tournamentId=" + id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.teamgroup = response.data;
                    }
                });
        },
       
        closePopupTeam() {
            this.isPopupTeam = false;
        },
        GetListPartipantPayment() {
            this.$API
                .get(this.$GetListParticipantByOrganizerUserId, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.participant = response.data;
                    }
                });
        },
        




    }



};
</script>